// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".containerCrumb {\n  align-items: center;\n  gap: 0.5rem;\n  padding-left: 1rem;\n}\n.containerCrumb:hover > .description {\n  cursor: pointer;\n  opacity: 0.8;\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
